import { CampaignsApi } from '../clients';
import { mapTargetOffice } from '../mappers';

/**
 * campaign-service's default page size for `/target-offices`
 * (`targetoffices.DefaultPageSize`). The service always echoes the size it
 * used; this only stands in if that echo is unreadable, so paging never
 * divides by nothing.
 */
const TARGET_OFFICES_DEFAULT_PAGE_SIZE = 50;

/**
 * One page of the offices a promo code's rule names, for the Office List
 * viewer.
 *
 * `total` is the count after the search, so it is what the pager and the
 * "N offices" line both read. A page past the end comes back with an empty
 * `items` and the true `total`.
 *
 * Errors propagate: the code itself has already loaded by the time the viewer
 * opens, so a 404 here is a failure, not "not found".
 */
export const getPromoCodeTargetOffices = async (campaignId, { page = 1, search = '' } = {}) => {
  const data = await CampaignsApi.getCampaignTargetOffices(campaignId, { page, q: search });
  const items = Array.isArray(data?.items) ? data.items : [];

  return {
    offices: items.map(mapTargetOffice),
    totalCount: Number(data?.total) || 0,
    page: Number(data?.page) || page,
    pageSize: Number(data?.pageSize) || TARGET_OFFICES_DEFAULT_PAGE_SIZE,
  };
};
